// extracted by mini-css-extract-plugin
export default {"label":"RadioLabel_label__RhVYJ"};